import { useParams } from 'react-router-dom';

const useExperienceId = () => {
  const { experienceId } = useParams();

  return experienceId?.split(/[?&]/)[0];
};

export default useExperienceId;
